import { generateVuexCrud, singleEntityRequest } from '@/utilities/crud/vuex';

const crud = generateVuexCrud({
    single: 'inventory',
    multiple: 'inventories',
});

const state = {
    ...crud.state,
};

const actions = {
    ...crud.actions,

    refreshInventory(store, { inventory }) {
        return singleEntityRequest('refreshOperation', {
            method: 'post',
            url: `/api/inventories/${inventory.id}/refresh`,
        });
    },

    refreshInventoryMetadata(store, { inventory }) {
        return singleEntityRequest('refreshOperation', {
            method: 'post',
            url: `/api/inventories/${inventory.id}/refreshMetadata`,
        });
    },
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
